import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControl,
  Select,
  MenuItem
} from '@material-ui/core'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined'
import { formStyles } from '../../Invoice/Steps/FormStyles'
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';

const InvoicesTypeForm = ({ onSubmit }) => {
  const classes = formStyles()
  const intl = useIntl()
  const [value, setValue] = React.useState('')

  const invoicesTypes = [
    {
      key: 'sent',
      name: intl.formatMessage({ id: 'invoicesTypes.sent' }),
      icon: <ArrowUpwardOutlinedIcon color={'primary'}/>,
    },
    {
      key: 'received',
      name: intl.formatMessage({ id: 'invoicesTypes.received' }),
      icon: <ArrowDownwardOutlinedIcon color={'secondary'}/>
    }
  ]
  const handleSelectChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setValue(event.target.value.toString())
    onSubmit(event.target.value.toString())
  }
  return (
    <form noValidate autoComplete="off" className={classes.formWrapper}>
      <div className={classes.FormItem + ' ' + classes.FormRow}>
        <FormControl variant="outlined" className={classes.FormItemSelect}>
          <Select
            fullWidth
            displayEmpty
            labelId={'invoiceDirection-label'}
            id={'invoiceDirection'}
            name={'invoiceDirection'}
            margin={'dense'}
            variant='outlined'
            MenuProps={{ disableScrollLock: true }}
            value={value}
            // label={intl.formatMessage({ id: 'Fields.label.view.InvoiceDirection' })}
            onChange={handleSelectChange}
          >
            <MenuItem value={''}>
              <div className={classes.invoiceDirectionWrapper}>
                <UnfoldMoreIcon/>
                <FormattedMessage id={'Table.List.Table.All'}/>
              </div>
            </MenuItem>
            {!!invoicesTypes?.length && invoicesTypes.map((item) => (
              <MenuItem key={item.key} value={item.key}>
                <div className={classes.invoiceDirectionWrapper}>
                  {item.icon}{item.name}
                </div>
              </MenuItem>))}
          </Select>
        </FormControl>
      </div>
    </form>
  )
}

export default InvoicesTypeForm
